export default "__VITE_ASSET__Bng7wRyH__"